"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LssImporterRisk = function LssImporterRisk(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z",
    fill: props.foregroundColor,
    stroke: props.foregroundColor,
    strokeWidth: "3"
  }), _react.default.createElement("path", {
    d: "M12 15.625C12.3452 15.625 12.625 15.3452 12.625 15C12.625 14.6548 12.3452 14.375 12 14.375C11.6548 14.375 11.375 14.6548 11.375 15C11.375 15.3452 11.6548 15.625 12 15.625Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 13.4999C12.1325 13.5 12.2596 13.4474 12.3534 13.3538C12.4472 13.2601 12.4999 13.1331 12.5 13.0005V8.99927C12.5 8.86666 12.4473 8.73948 12.3536 8.64571C12.2598 8.55195 12.1326 8.49927 12 8.49927C11.8674 8.49927 11.7402 8.55195 11.6464 8.64571C11.5527 8.73948 11.5 8.86666 11.5 8.99927V13.0005C11.5001 13.1331 11.5528 13.2601 11.6466 13.3538C11.7404 13.4474 11.8675 13.5 12 13.4999Z",
    fill: props.foregroundColor
  }));
};

LssImporterRisk.defaultProps = {
  altText: "Lss Importer Risk",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
LssImporterRisk.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = LssImporterRisk;
exports.default = _default;